module.exports = __webpack_public_path__ + "static/media/logo-youtube.bad4875e.svg";